import { motion } from "framer-motion";

export default function SaveSuccess() {
  return (
    <motion.div
      key="loading"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0 }}
      exit={{ opacity: 0, transition: { duration: 0.2 } }}
    >
      <div className="row my-5">
        <div className="col-sm-12">
          <div className="alert alert-success" role="alert">
            <div className="mb-3">
              <h2>
                <i className="bi bi-check-circle text-success me-2"></i> Konto
                zostało zarejestrowane
              </h2>
            </div>
            <div>
              <p>Twoje konto zostało zarejestrowane w systemie.</p>
              <p>
                Na podany adres e-mail wysłana została wiadomość. Gdy otrzymasz
                wiadomość, kliknij na łącze w wiadomości aby potwierdzić swój
                adres e-mail.
              </p>
              <p>Możesz teraz zamknąć okno przeglądarki.</p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
